/**
 * @generated SignedSource<<531d80e7445ae683f74512f9503f3243>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionFilterRelay_softwareFilters$data = ReadonlyArray<{
  readonly node: {
    readonly name: string;
    readonly project: {
      readonly key: string;
    } | null | undefined;
    readonly versionId: string;
  };
  readonly " $fragmentType": "versionFilterRelay_softwareFilters";
}>;
export type versionFilterRelay_softwareFilters$key = ReadonlyArray<{
  readonly " $data"?: versionFilterRelay_softwareFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionFilterRelay_softwareFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "versionFilterRelay_softwareFilters",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersion",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "versionId"
            },
            "action": "THROW",
            "path": "node.versionId"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "node.name"
          },
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    }
  ],
  "type": "JiraVersionEdge"
};

(node as any).hash = "ecd6dfc3c566dfd4b3cd5078c4c50713";

export default node;
